import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { BASE_URL, GET_EXECUTIVE_MEMBER_SESSIONS, GET_EXECUTIVES_member } from "../../constant/constants";

const Executive = (props) => {
  const [executiveMembers, setExecutiveMembers] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOptions, setSelectedOptions] = useState('');
  const [currentPage, setCurrentPage] = useState(1);




  const { id } = useParams();
  console.log("projecID", selectedOption);

  useEffect(() => {
    fetch(`${GET_EXECUTIVE_MEMBER_SESSIONS}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('dataahgsfhasgfdh',data)
        setSelectedOptions(data);
      })
      .catch(() => {});
  }, [id]);

  //for content images
  useEffect(() => {
    fetch(`${GET_EXECUTIVES_member}`)
      .then((response) => response.json())
      .then((data) => {
        setExecutiveMembers(data.executive_members);
        console.log("executive_members", data.executive_members);
      })
      .catch(() => {});
  }, [id, props.id]);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    handleSelect(event.target.value); 
  };



const handleSelect = async (option) => {
  try {
    const response = await fetch(`${GET_EXECUTIVES_member}?key=${option}`);
    
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    
    const data = await response.json();
    if (data?.executive_members) {
      setExecutiveMembers(data.executive_members);
      console.log("executive_members", data.executive_members);
    } else {
      console.warn("No executive members found in the response.");
    }
  } catch (error) {
    console.error("Failed to fetch executive members:", error.message || error);
  }
};

    const handlePageClick = (page) => {
    setCurrentPage(page);
    // Perform additional actions when a page is clicked (e.g., fetch data)
  };
const renderPagination = () => {
  const paginationItems = [];

  // Add 'Previous' link
  paginationItems.push(
    <li
      key='previous'
      className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
      <a
        className='page-link'
        href='#'
        tabIndex='-1'
        onClick={() => handlePageClick(currentPage - 1)}>
        Previous
      </a>
    </li>
  );

  // Add page links
  for (let i = 1; i <= executiveMembers?.total_pages; i++) {
    paginationItems.push(
      <li
        key={i}
        className={`page-item${currentPage === i ? ' active' : ''}`}>
        <a className='page-link' href='#' onClick={() => handlePageClick(i)}>
          {i}
        </a>
      </li>
    );
  }

  // Add 'Next' link
  paginationItems.push(
    <li
      key='next'
      className={`page-item${
        currentPage === executiveMembers?.total_pages ? ' disabled' : ''
      }`}>
      <a
        className='page-link'
        href='#'
        onClick={() => handlePageClick(currentPage + 1)}>
        Next
      </a>
    </li>
  );

  return paginationItems;
};

  return (
    

    <section
    className={`${props.Fclass} section-padding  ${props.vclassClass}`}>
         {/* filter Drop Down */}
      

    <div className='container'>
      {
        selectedOptions &&
        (




<div className='row mb-4 px-4 mt-3'>
<div className='col-md-2  ' style={{ textAlign: 'right' }}>
  <h5>Session :</h5>
</div>

<div className='col-md-4 col-md-4 col-4 mb-4 form  '>
  <div className='form-field rounded'>
    <select
      className='form-control'
      onChange={handleChange}
      type='text'
      name='session'
      id='session'
      value={ selectedOption|| selectedOptions[0]}
      style={{ borderRadius: '20px' }}>
      <option value='without_photo'>Select Session</option>
      {selectedOptions?.map((selectedOption, index) => (
        <option key={index} value={selectedOption}>
          {selectedOption}
        </option>
      ))}
    </select>
  </div>
</div>
</div>
        )
      }

      <div className='row'>

        {executiveMembers.map(
          (executiveMember) =>
         
              <div
                className='col col-xl-4 col-lg-6 col-sm-6 col-12  my-3'
                key={executiveMember?.member?.id}
                style={{
                  height: '600px',
                }}>
                <div
                  className=' shadow mb-5 bg-gray'
                  style={{
                    borderTopRightRadius: '30px',
                    borderBottomLeftRadius: '30px',
                  }}>
                  <div
                    className='text-center py-1 text-white mb-4 '
                    style={{
                      backgroundColor: '#192847',
                      borderTopRightRadius: '20px',
                      fontSize: '20px',
                      fontWeight: '700',
                      height: '45px',
                    }}>
                    {executiveMember?.designation || ' '}
                  </div>
                  <div className='img-holder justify-content-center  d-flex position-relative'>
                    <img
                      src={
                        executiveMember?.member?.image
                          ? `${BASE_URL}${executiveMember?.member?.image}`
                          : '/userColor.png'
                      }
                      alt={executiveMember.first_name}
                      className='mb-3 text-center'
                      width='170'
                      height='170'
                      style={{
                        borderTopLeftRadius: '40px',
                        borderBottomRightRadius: '40px',
                        border: '3px solid #bfbdbd',
                      }}
                    />
                    <span
                      className='position-absolute text-center mx-auto text-white rounded-circle p-2'
                      style={{
                        fontSize: '18px',
                        bottom: '5px',
                        right: '120px',
                        width: '50px',
                        margin: '2px',
                        backgroundColor: '#192847',
                        border: '5px solid white',
                        display: 'flex',
                        textAlign: 'center',
                        justifyContent: 'center',
                      }}>
                      {executiveMember?.order_no || 0}
                    </span>
                  </div>

                  <div
                    className='p-4 pb-0 py-2 text-center'
                    style={{
                      height: '270px',
                    }}>
                    <h3 className='text-center'>
                      {executiveMember?.member?.first_name} {executiveMember?.member?.last_name}
                    </h3>
                    <h5 className='text-center' style={{ color: '#319336' }}>
                      {executiveMember?.member?.profession || 'N/A'}
                    </h5>
                    <span>Address : {executiveMember?.member?.street_address_one} </span>{' '}
                    <br />
                    <span className='mb-0'>
                      Contact : {executiveMember?.member?.primary_phone},{' '}
                      {executiveMember?.member?.others_phone}{' '}
                    </span>
                    <br />
                    <span>
                      Email: {executiveMember?.member?.email} ,{executiveMember?.member?.others_email}
                    </span>
                    <br />
                    {executiveMember?.member?.website && (
                      <span>Website: {executiveMember?.member?.website}</span>
                    )}
                  </div>
                  <div
                      className='text-center py-1 mt-2 text-white mb-4 '
                      style={{
                        backgroundColor: '#319336',
                        borderBottomLeftRadius: '20px',
                        fontSize: '20px',
                        fontWeight: '700',
                        height: '45px',
                      }}>
                      Membership No-
                      <span style={{ height: '45px' }}>
                        {(executiveMember?.membership_no || '')
                          .toString()
                          .padStart(3, '0')}
                      </span>
                    </div>
                </div>
              </div>
          
        )}
      </div>
    </div>
   
  </section>
  );
};

export default Executive;
